import React from 'react';
import { DateFormat, DateFormats } from '../../../_lib/components/DateFormat';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type DateRanger = {
  start: string;
  end: string;
  multiDayEvent: boolean;
  allDayEvent: boolean;
};

/**
 * Depending on the params multiDayEvent, allDayEvent DateRanger renders
 * different <a href='#dateformat'>DateFormat</a>s.
 */
export function DateRanger({ start, end, allDayEvent, multiDayEvent }: DateRanger) {
  const { t } = useSonTranslation('DateRanger');

  if (allDayEvent) {
    if (multiDayEvent) {
      // multiDay = 29.03.2018 (00:00 Uhr) bis 30.03.2018 (23:59 Uhr) (ganztägig)
      return (
        <>
          <DateFormat date={start} format={DateFormats.DATE_TIME_HIDDEN} /> {t('until')}{' '}
          <DateFormat date={end} format={DateFormats.DATE_TIME_HIDDEN} /> ({t('allDay')})
        </>
      );
    }

    // singleDay = 29.03.2018 (ganztägig)
    return (
      <>
        <DateFormat date={start} format={DateFormats.DATE_TIME_HIDDEN} />
        <span className="invisible">
          {' '}
          {t('until')} <DateFormat date={end} format={DateFormats.DATE_TIME} />
        </span>{' '}
        ({t('allDay')})
      </>
    );
  }

  if (multiDayEvent) {
    // multiDayTimeRange = 29.03.2018 (08:30 Uhr) bis 30.03.2018 (16:15 Uhr)
    return (
      <>
        <DateFormat date={start} format={DateFormats.DATE_TIME_BRACES} /> {t('until')}{' '}
        <DateFormat date={end} format={DateFormats.DATE_TIME_BRACES} />
      </>
    );
  }

  // singleDayTimeRange = 29.03.2018 (08:30 bis 16:15 Uhr)
  return (
    <>
      <DateFormat date={start} format={DateFormats.DATE_TIME_OPEN_BRACE} /> {t('until')}{' '}
      <DateFormat date={end} format={DateFormats.DATE_TIME_CLOSING_BRACE} />
    </>
  );
}
